
import { defineComponent, onMounted } from 'vue';
import {
  YANDEX_CAPTCHA_KEY,
  YANDEX_CAPTCHA_URL,
} from 'SharedDir/constants/app/endpoints';

export default defineComponent({
  name: 'YandexCaptcha',
  data() {
    return {
      YANDEX_CAPTCHA_KEY,
    };
  },
  setup() {
    const getYandexCaptchaWidget = () => {
      const recaptchaScript = document.createElement('script');
      recaptchaScript.setAttribute('src', YANDEX_CAPTCHA_URL as string);
      recaptchaScript.setAttribute('defer', 'defer');
      document.head.appendChild(recaptchaScript);
    };

    onMounted(() => getYandexCaptchaWidget());

    return {};
  }
});
